import React from 'react';
import '../styles/AnimatedLine.css';

const AnimatedLine = () => {
  return (
    <div className="animated-line">
      <div className="line-glow"></div>
    </div>
  );
};

export default AnimatedLine;